import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import LivenessQRCode from './LivenessQRCode';

const SessionView: React.FC = () => {
  const { sessionId } = useParams<{ sessionId: string }>();
  const location = useLocation();
  const livenessSessionToken = new URLSearchParams(location.search).get('token') ?? undefined;

  if (!sessionId) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="text-red-600">Session ID is required</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 py-6 flex flex-col justify-center sm:py-12">
      <div className="relative py-3 sm:max-w-full sm:mx-auto">
        <div className="relative px-4 py-10 bg-white shadow-xl sm:rounded-2xl sm:p-20">
          <div className="max-w-md mx-auto">
            <LivenessQRCode
              sessionId={sessionId}
              livenessSessionToken={livenessSessionToken}
              className="w-full"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SessionView;
